/**
 * DfdProfile — Data Flow Diagrams (Yourdon-DeMarco + Gane-Sarson).
 * See plans/software-design/domain.md § 9.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type DfdNodeType = 'dfd_process' | 'dfd_datastore' | 'dfd_external';
export type DfdEdgeType = 'dfd_dataflow';

export const DfdProfile: DomainDataProfile<DfdNodeType, DfdEdgeType> = {
  domainId: 'dfd',
  profileVersion: '1.0',
  diagramTypes: ['flowchart' as DiagramType],
  nodeTypes: ['dfd_process', 'dfd_datastore', 'dfd_external'],
  edgeTypes: ['dfd_dataflow'],
  vocabulary: {
    recordSingular: 'Process',
    recordPlural: 'Processes',
    repositoryLabel: 'System',
    hierarchyLabel: 'Data Flow',
    importAction: 'Import DFD',
    keyColumnHint: 'Process',
    commitLabel: 'Push DFD',
    pullLabel: 'Refresh DFD',
    diagramLabel: 'data flow diagram',
  },
  fieldAliases: {
    name: ['processName', 'processId'],
  },
  requiredProps: ['name'],
  recommendedProps: [],
  primaryShapeType: 'dfd_process',
  propsToAttrsMapping: {
    name: 'name',
    level: 'level',
    notation: 'notation', // yourdon | gane-sarson
  },
  relationshipPackId: 'software-design-relationships',
};
